import { NavInnerContainerDiv } from './NavInnerContainer.styled';

export const NavInnerContainer = ({ children }) => {
  return <NavInnerContainerDiv>{children}</NavInnerContainerDiv>;
};
